module.exports = __webpack_public_path__ + "media/images/hanko-3572098214ab9021e8b196c4bb4c4747.png";